import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=7ecb2abe"
import script from "./Module.vue?vue&type=script&lang=ts"
export * from "./Module.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports